import { memo } from 'react'

import type { AcfTravelSpecialistPromoProps } from '@typings'
import {
  RaButton,
  RaContainer,
  RaHeading,
  RaIcon,
  RaImage,
  RaPaper,
  RaRichText,
} from '@components/core/index.core'
import { RaFormDialogButton } from '@components/form-elements/RaFormDialogButton/RaFormDialogButton'
import { ICONS } from '@constants/icons.constants'

import styles from './acf-travel-specialist-promo.module.scss'

export const AcfTravelSpecialistPromo = memo(
  ({
    image,
    title,
    phone,
    content,
    cta,
    form,
    formData,
    destination,
  }: AcfTravelSpecialistPromoProps) => {
    return (
      <RaContainer>
        <div className={styles['acf-travel-specialist-promo__container']}>
          <RaPaper
            padding={6}
            paddingMobile={4}
            hoverAnimations={['shadow']}>
            <div className={styles['acf-travel-specialist-promo']}>
              <div className={styles['acf-travel-specialist-promo__content']}>
                <RaHeading component="h3">{title.title}</RaHeading>
                <RaRichText content={content} />
                <div className={styles['acf-travel-specialist-promo__buttons']}>
                  <RaFormDialogButton
                    form={form}
                    formData={formData}
                    label={cta}
                    modalTitle={title.title}
                    fullscreen={false}
                    destination={destination}
                  />
                  <RaButton
                    variant="secondary-dark"
                    link={{
                      url: `tel:${phone.replace(' ', '')}`,
                      title: phone,
                    }}
                    startIcon={
                      <RaIcon
                        icon={ICONS.MOBILE_DRAWING}
                        color="dark"
                      />
                    }
                  />
                </div>
              </div>
              <div className={styles['acf-travel-specialist-promo__image']}>
                <RaImage
                  image={image}
                  rotate="right"
                  elevation="light"
                />
              </div>
            </div>
          </RaPaper>
        </div>
      </RaContainer>
    )
  },
)
